// extracted by mini-css-extract-plugin
export default {"img":"selected_product_img__D2gmq","container":"selected_product_container__AK-wt"};